import { Inject, Injectable } from '@angular/core';
import { HOME_REPOSITORY } from '../token/home.token';
import { IHomeRepository } from '../../domain/repository/home.respository';

@Injectable()
export class HomeApplication {
  constructor(@Inject(HOME_REPOSITORY) private repo: IHomeRepository) {}
  getHomeFeatures(ownerId: number, activeProjects?: boolean, limit?: number) {
    return this.repo.getHomeFeatures(ownerId, activeProjects, limit);
  }
  getHomeFeaturesById(id: number) {
    return this.repo.getHomeFeaturesById(id);
  }
}
